export default {
  'openEndedQuestion.title': 'Open Ended Question',
  'openEndedQuestion.crateTitle': 'Create Open Ended Question',
  'openEndedQuestion.duplicateTitle': 'Duplicate Open Ended Question',
  'openEndedQuestion.questionContentTitle': 'Question Content',
  'openEndedQuestion.questionContentSubtitle':
    'Prepare the content of the question',
  'openEndedQuestion.expectedAnswer': 'Expected Answer',
};
